<template>
    <section>
        <div>
            <Heading v-if="showHeading" :title="title" class="xl:!pt-10 xl:!px-[25vw] px-4"/>
            <div :class="backgroundBlue ? 'component-background-blue-desktop' : ''">
                <div v-if="showBackButton" class="flex justify-items-start justify-self-stretch xl:px-[25vw] px-4 pt-12 mb-8">
                    <SetaEsquerda class="!text-[#2E59FF] hover:text-blue-600 w-4"/>
                    <button @click="goBack" class="back-sm hover:text-blue-600 hover:underline text-xs text-[#2E59FF]">Voltar</button>
                </div>
                <div :class="showLogo ? 'block' : 'hidden'" class="flex justify-center py-20 px-4">
                    <!-- <Back v-if="showBackButton" state="back" class="pt-40 xl:px-[34vw]"/> -->

                    <img :class="showLogo ? 'block' : 'hidden'" src="/images/logo-invertido.png" alt="" class="max-w-[550px] sm:max-w-[200px] w-full" />
                </div>

                <div class="sm:block xl:px-[25vw] pb-40">
                    <slot />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Header from "@/Components/UI/Nav/Header.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';
import Back from '@/Components/UI/Back.vue';
import SetaEsquerda from "@/Components/UI/Icons/SetaEsquerda.vue"

export default {
    components: {
        Header,
        Heading,
        Back,
        SetaEsquerda
    },
    props: {
        showLogo: Boolean,
        title: String,
        showHeading: {
            type: Boolean,
            default: true
        },
        showBackButton: {
            type: Boolean,
            default: true
        },
        backgroundBlue: {
            type: Boolean,
            deafult: false
        }
    },
    methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
};
</script>
